export default "__VITE_ASSET__DT0UMTtg__"